module.exports = __webpack_public_path__ + "img/product-shot_01_loading.bffece43.jpg";